import { render } from "./Result.vue?vue&type=template&id=058d231c&scoped=true&ts=true"
import script from "./Result.vue?vue&type=script&lang=ts"
export * from "./Result.vue?vue&type=script&lang=ts"

import "./Result.vue?vue&type=style&index=0&id=058d231c&scoped=true&lang=css"

import exportComponent from "/root/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-058d231c"]])

export default __exports__